module.exports = __webpack_public_path__ + "static/media/i8-2-mike.68ff3098.png";